module.exports = __webpack_public_path__ + "static/media/refresh.0adf04d9.svg";